import _ from 'lodash';
import { SET_FOOTER_UPSELL_COLLECTION } from './FooterUpsellActions';

const INITIAL_STATE = {
  members: [],
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_FOOTER_UPSELL_COLLECTION: {
      const panels = action.payload;
      const members = _.get(panels, 'member.0.items.member', []);
      return { members };
    }
    default:
      return state;
  }
}
